import { render, staticRenderFns } from "./BasePaginationWithoutUpdate.vue?vue&type=template&id=64625e09&"
import script from "./BasePaginationWithoutUpdate.vue?vue&type=script&lang=js&"
export * from "./BasePaginationWithoutUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports